import React, { useState } from "react";
import { BuildAddress } from "./functions";

const ReapITProperty = ({ Data }) => {
  const [SelectedImage, setSelectedImage] = useState(Data.featuredImageUrl);
  return (
    <div style={{ marginBottom: "3rem" }}>
      <h4>{BuildAddress(Data.address)}</h4>
      <p className="text-grey">
        <span className="mr-1">
          <b>Bedrooms:</b> {Data.bedrooms}
        </span>
        <span className="mr-1">
          <b>Bathrooms:</b> {Data.bathrooms}
        </span>
        <span className="mr-1">
          <b>Receptions:</b> {Data.receptions}
        </span>
        <span className="mr-1">
          <b>Price:</b> £{Data.selling.price}
        </span>
      </p>
      <p>{Data.description}</p>

      <div className="flex-row">
        <div className="two-thirds">
          {Data._embedded &&
            Data._embedded.images &&
            Data._embedded.images
              .sort((a, b) => (a.order < b.order ? -1 : 1))
              .map((itm, idx) => (
                <img
                  key={idx}
                  className="thumb link"
                  src={itm.url}
                  alt="Thumbnail"
                  onClick={() => setSelectedImage(itm.url)}
                />
              ))}
        </div>
        <div className="one-third">{SelectedImage > "" && <img src={SelectedImage} alt="Main" className="main" />}</div>
      </div>
    </div>
  );
};

export default ReapITProperty;
